import 'es6-promise/auto'
import '@/utils/configuration'
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import Buefy from 'buefy'
import VueTimeago from 'vue-timeago'
import 'buefy/dist/buefy.css'
import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-regular.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-brands.css'
import VeeValidate from 'vee-validate'
import '@/css/app.css'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/api'

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

Vue.use(Vue2Filters)

Vue.use(VeeValidate, {
  events: ''
})

Vue.use(VueTimeago, {
  name: 'timeago',
  locale: 'en-US'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
